"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importDefault(require("react"));
var react_dom_factories_1 = __importDefault(require("react-dom-factories"));
var MarkupManyComponents_1 = __importDefault(require("./MarkupManyComponents"));
/**
 * Use this when you need to mark up certain text with HTML. For example, to get:
 *  <span>Click <a href="location">here</a> to sign up!</span>
 * You'd do the following:
 *   var componentProps = { href: "location" }
 *   <MarkupSingleComponent markedUpComponentProps={componentProps}>
 *       Click [here|key] to sign up!
 *   </MarkupSingleComponent>
 *
 * If you're calling this from a translation (which is pretty much why this exists),
 * your key should look like the following:
 * var key = "Click [here|{0}] to sign up!"
 * gt.gettext(key, "key");
 *
 *
 * Sidebar
 * I can't think of a better way of doing this, so for now, you have to pass in "key".
 *
 * I thought about doing a replace, or just not doing the substitution at all, but
 * it seemed prone to error.
 * /Sidebar
 *
 * If you need to do this for MANY components, use MarkupManyComponents
 * (which is what this wraps anyway).
 *
 * @deprecated Use `MarkupComponents` instead. See README for migration guide.
 */
var MarkupSingleComponent = /** @class */ (function (_super) {
    __extends(MarkupSingleComponent, _super);
    function MarkupSingleComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkupSingleComponent.prototype.render = function () {
        var markedUpComponents = {
            key: {
                componentType: this.props.markedUpComponentType || react_dom_factories_1.default.a,
                props: this.props.markedUpComponentProps
            }
        };
        return (react_1.default.createElement(MarkupManyComponents_1.default, { elementType: this.props.elementType, markedUpComponents: markedUpComponents }, this.props.children));
    };
    return MarkupSingleComponent;
}(react_1.default.Component));
exports.default = MarkupSingleComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFya3VwU2luZ2xlQ29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc291cmNlL3NyYy9NYXJrdXBTaW5nbGVDb21wb25lbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsdURBQXVEO0FBQ3ZELGdEQUEwQjtBQUMxQiw0RUFBc0M7QUFDdEMsZ0ZBQWlGO0FBb0JqRjs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7R0EwQkc7QUFDSDtJQUFvQyx5Q0FBc0I7SUFBMUQ7O0lBa0JBLENBQUM7SUFqQlUsc0NBQU0sR0FBYjtRQUNJLElBQU0sa0JBQWtCLEdBQUc7WUFDdkIsR0FBRyxFQUFFO2dCQUNELGFBQWEsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLHFCQUFxQixJQUFJLDZCQUFHLENBQUMsQ0FBQztnQkFDeEQsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsc0JBQXNCO2FBQzNDO1NBQ0osQ0FBQztRQUVGLE9BQU8sQ0FDSCw4QkFBQyw4QkFBb0IsSUFDakIsV0FBVyxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxFQUNuQyxrQkFBa0IsRUFBRSxrQkFBa0IsSUFFckMsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQ0QsQ0FDMUIsQ0FBQztJQUNOLENBQUM7SUFDTCw0QkFBQztBQUFELENBQUMsQUFsQkQsQ0FBb0MsZUFBSyxDQUFDLFNBQVMsR0FrQmxEO0FBRUQsa0JBQWUscUJBQXFCLENBQUMifQ==